import { apiGateway } from '../api';

async function buscarCartaReajuste(numeroContrato) {
    try {
        const response = await apiGateway.get(`/contratos/${numeroContrato}/carta-reajuste`);
        return response;
    } catch (error) {
        return error;
    }
}

async function gerarBateCadastral(dtSituacaoAssociado, numContrato, paramContrato, situacaoAssociado) {
    try {
        const params = new URLSearchParams();
        params.append('dtSituacaoAssociado', dtSituacaoAssociado);
        params.append(paramContrato, numContrato);

        if (situacaoAssociado) {
            params.append('situacaoAssociado', situacaoAssociado);
        }

        const response = await apiGateway.get(`/batecadastral/gerar`, { params });
        return response;
    } catch (error) {
        return error;
    }
}

async function downloadBateCadastral(dtInicial, dtFinal, id) {
    try {
        const params = new URLSearchParams();
        params.append('dtInicial', dtInicial);
        params.append('dtFinal', dtFinal);
        params.append('id', id);

        const response = await apiGateway.get(`/batecadastral/download`, { params });

        return response;
    } catch (error) {
        return error.response;
    }
}

export { buscarCartaReajuste, gerarBateCadastral, downloadBateCadastral };
